export default class numericMask {
    numeric(separator, maxLength = null) {
        if (maxLength === null) {
            return `/^[0-9]+(${separator}?)([0-9]{0,2})?$/`;
        }

        return `/^\\d{1,${maxLength}}$/`;
    }
}
